import React, {useState, useEffect} from "react";
import CommuteCalendar from "../components/CommuteCalendar";
import CommuteBox from "../components/CommuteBox";
import assets from "../assets/imgs";
import {useUser} from "../context/UserContext";
import useIsMobile from "../hooks/useIsMobile";
import config from "../config/config";
const API_URL = config.API_URL;

function Commute() {
  const [data, setData] = useState([]);
  const isMobile = useIsMobile(); 
  const [baseGpsExist, setBaseGpsExist] = useState(true);
  const [gps, setGps] = useState({lat: null, lon: null});
  const [platform, setPlatform] = useState({device: "unknown", os: "unknown"});
  const [hasCommute, setHasCommute] = useState({출근 : false, 퇴근 : false});
  const [commuteInfo, setCommuteInfo] = useState({time: null, outCommute: null});
  const [loading, setLoading] = useState(true);
  const {authority, company} = useUser();

  useEffect(() =>{
    if(navigator.geolocation){
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setGps({
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          });
        },
        (error) =>{
          console.log("GPS Error: ", error);
        }
      );
    }else{
      console.warn("Geolocation is not supported by this browser");
    }
  }, []);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    let device = "PC";
    let os = "Unknown";

    if (/android/i.test(userAgent)) {
      device = "Mobile";
      os = "Android";
    } else if (/iphone|ipad|ipod/i.test(userAgent)) {
      device = "Mobile";
      os = "iOS";
    } else if (/macintosh|mac os x/i.test(userAgent)) {
      os = "MacOS";
    } else if (/windows/i.test(userAgent)) {
      os = "Windows";
    }

    setPlatform({ device, os });
  }, []);

  useEffect(() => {
    checkCommute();
  }, []);

  const checkCommute = async () => {
    try {
      //gps 등록과정 임시 보류 250428
      // const gpsResponse = await fetch(`${API_URL}/api/commute/checkStartupGPS`, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   credentials: "include",
      // });
      // const gpsContent = await gpsResponse.json();
      // if(gpsContent.result){
      //   setBaseGpsExist(true);       
        
      // }else{

      // }
      const response = await fetch(`${API_URL}/api/commute/commuteCheck`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          commuteValue: "출근",
        }),
      });

      const commuteResponse = await response.json();
      setCommuteInfo({
        time: commuteResponse.time || null,
        outCommute: commuteResponse.out_commute || null,
      });

      const response2 = await fetch(`${API_URL}/api/commute/commuteCheck`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          commuteValue: "퇴근",
        }),
      });

      const commuteResponse2 = await response2.json();
      console.log(commuteResponse);
      console.log(commuteResponse2);

      setHasCommute({
        출근: commuteResponse.alreadyCommute,
        퇴근: commuteResponse2.alreadyCommute,
      });

    } catch (error) {
      console.error("Error checking commute status:", error);
    }finally{
      setLoading(false);
    }
  };

  const waitForGps = (timeoutMs = 1000) => {
    return new Promise((resolve, reject) => {
      const start = Date.now();
  
      const check = () => {
        if (gps.lat !== null && gps.lon !== null) {
          resolve(); // gps가 준비되면 resolve
        } else if (Date.now() - start >= timeoutMs) {
          reject(); // 1초 초과하면 reject
        } else {
          setTimeout(check, 100); // 0.1초 간격으로 다시 체크
        }
      };
  
      check();
    });
  };
  

  // // gps 등록과정 임시 보류 250428
  // const enrollGps = async ()=>{
  //   if(authority === 3 || authority === 4 || authority === 6){
  //     if(navigator.permissions){
  //       navigator.permissions.query({name: 'geolocation'}).then(async function(permissionStatus) {
  //         if(permissionStatus.state === 'granted'){
  //           try{
  //             if (gps.lat === null || gps.lon === null) {
  //               await waitForGps(); // gps 준비될 때까지 대기
  //             }
  
  //             try{
  //               const response = await fetch(`${API_URL}/api/startup/setGps`, {
  //                 method: "POST",
  //                 headers: {
  //                   "Content-Type": "application/json",
  //                 },
  //                 credentials: "include",
  //                 body: JSON.stringify({
  //                   gps: gps,
  //                 }),
  //               });
  //               const result = await response.json();
  //               if(result.result){
  //                 setBaseGpsExist(true);
  //                 alert('GPS 등록을 완료하였습니다.');
  //               }else{
  //                 alert(`GPS 등록에 실패하였습니다, ${result.message}`);
  //               }
  //             }catch(innerError){
  //               alert(`GPS 등록에 실패하였습니다, ${innerError}`);
  //             }
  //           }catch(error){
  //             alert('GPS 정보를 가져오는 데 실패했습니다. 새로고침 후 재시도 부탁드립니다.');
  //           }
  //         }else if(permissionStatus.state === 'prompt'){
  //           alert('주소창 우측 끝의 GPS 권한을 승인해 주시기 바랍니다.');
  //         }else{
  //           alert('주소창 우측 끝의 GPS 권한을 승인해 주시기 바랍니다.');
  //         }
  //       })
  //     }else{
  //       alert('지원이 불가능한 브라우저 입니다. 관리자에게 문의하여 주시기 바랍니다.');
  //     }
  //   }else{
  //     alert('권한이 부족합니다.');
  //   }
  // }
  async function checkGpsStatus() {
    // 1. 브라우저가 Geolocation API를 지원하는지 확인
    if (!navigator.geolocation) {
      const confirmed = window.confirm("이 브라우저에서는 GPS를 지원하지 않습니다.\nGPS 권한이 없으면 관외 출근으로 처리됩니다.\n계속하시겠습니까?");
      return confirmed;
    }
  
    // 2. 권한 확인
    const permission = await navigator.permissions?.query?.({ name: "geolocation" }).catch(() => null);
  
    if (permission && permission.state === "denied") {
      const confirmed = window.confirm("GPS 권한이 없습니다.\nGPS 권한이 없으면 관외 출근으로 처리됩니다.\n계속하시겠습니까?");
      return confirmed;
    }
  
    // 3. gps 값이 없는 경우
    // console.log('gps permission', permission.state);
    if(permission.state === 'granted'){
      // console.log('in first gps, ', gps, gps.lat == null, gps.lon == null);
      if (!gps || gps.lat == null || gps.lon == null) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setGps({
              lat: position.coords.latitude,
              lon: position.coords.longitude,
            });
          },
          (error) =>{
            console.log("GPS Error: ", error);
          }
        );
        // console.log('in second:' , gps, gps.lat == null, gps.lon == null);
        if (!gps || gps.lat == null || gps.lon == null){
          alert("GPS 수신 중 입니다.\n잠시 후 재시도하여 주시기 바랍니다.");
          return false;
        }
      }  
    }
    
    return true;
  }

  const handleCommute= async (commuteType)=>{
    // console.log('upper', gps);
    const gpsOk = await checkGpsStatus();
    if (!gpsOk) return;
    // console.log('lower', gps);
    if(commuteType === "퇴근"){
      const unCommuteCheck = window.confirm(`
        퇴근을 수행하고 나면 해당 날짜의 출근은 변경 불가능 합니다. 
        \n 계속 진행하시겠습니까?
      `);
      if(!unCommuteCheck){
        return null;
      }
    }

    let reCommute = false;
    if(commuteType === "출근" && hasCommute.출근){
      const now = new Date();
      const formatted = now.toLocaleString();  

      const commuteCheck = window.confirm(`
        이미 ${commuteInfo.time}에 ${commuteInfo.outCommute}로 출근 수행되었습니다.
        \n ${formatted}, 현재 위치로 변경하시겠습니까? 
      `);
      if(!commuteCheck){
        return null;
      }
      reCommute = true;
    }

    try {
      const response = await fetch(`${API_URL}/api/commute/commute`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          // user_id: 123, // 로그인된 사용자 ID
          gps,
          platform,
          commute: commuteType,
          re_commute: reCommute, 
        }),
      });
  
      const result = await response.json();
      if (response.ok) {
        alert(result.message);
        checkCommute();
        fetchData();
      } else {
        alert(result.message || `${commuteType} 체크 실패`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert(`${commuteType} 체크 중 오류 발생`);
    }
  };

  const handleDisabledClick = (message) =>{
    alert(message);
  }

  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/commute/getCommuteCalendar`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result && Array.isArray(result.value)) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.map((row, index) => ({
          date: row.date,
          complete: row.complete || 0,
          doing: row.doing || 0,
          // date: row.log_date ? row.log_date.split("T")[0] : "-", // 날짜만 추출,
        }));
        setData(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching board data:", error);
      // setError(error.message); // 에러 메시지 저장
    } 
  };
  useEffect(() => {
    fetchData();
  }, []);
  // console.log('data is :', data);

  if(isMobile){
    return ( 
      <div style={mobileStyles.container}>
        <div style={mobileStyles.rowBox}>
          {baseGpsExist ? (
            <>
              <CommuteBox 
                text="출근"
                icon= {assets.icons.red_pin}
                onClick={
                  loading 
                    ? () => handleDisabledClick("로딩중입니다.")
                    : (hasCommute.출근 && hasCommute.퇴근)
                      ? () => handleDisabledClick("이미 퇴근까지 완료되었습니다.")
                      : () => handleCommute("출근")
                }
                // onClick={() => handleCommute("출근")}
                btnText="출근"
                disabled={(hasCommute.출근 && hasCommute.퇴근) || loading}
                detail = {hasCommute.출근 ? `${commuteInfo.time}, ${commuteInfo.outCommute}` : null}
              />
              <CommuteBox
                text="퇴근"
                icon= {assets.icons.red_bus}
                onClick={
                  loading
                    ? () => handleDisabledClick("로딩중입니다.")
                    : hasCommute.퇴근
                      ? () => handleDisabledClick("퇴근이 이미 되어 있습니다.")
                      : hasCommute.출근
                      ? () => handleCommute("퇴근")
                      : () => handleDisabledClick("출근을 먼저 해주세요.")
                }
                // onClick={() => handleCommute("퇴근")}
                btnText="퇴근"
                disabled={!hasCommute.출근 || hasCommute.퇴근 || loading}
              />
            </>
          ): (
            <CommuteBox
              text="기업 GPS 등록하기"
              icon= {assets.icons.red_pin}
              // onClick = {enrollGps}
              btnText="등록하기"
              disabled = {baseGpsExist}
            />
          )}          
        </div>
      </div>
    );
  }else{
    return ( 
      <div style={styles.container}>
        <div style={styles.rowBox}>
          {baseGpsExist ? (
            <>
              <CommuteBox 
                text="출근"
                icon= {assets.icons.red_pin}
                onClick={
                  loading 
                    ? () => handleDisabledClick("로딩중입니다.")
                    : (hasCommute.출근 && hasCommute.퇴근)
                      ? () => handleDisabledClick("이미 퇴근까지 완료되었습니다.")
                      : () => handleCommute("출근")
                }
                // onClick={() => handleCommute("출근")}
                btnText="출근"
                disabled={(hasCommute.출근 && hasCommute.퇴근) || loading}
                detail = {hasCommute.출근 ? `${commuteInfo.time}, ${commuteInfo.outCommute}` : null}
              />
              <CommuteBox
                text="퇴근"
                icon= {assets.icons.red_bus}
                onClick={
                  loading
                    ? () => handleDisabledClick("로딩중입니다.")
                    : hasCommute.퇴근
                      ? () => handleDisabledClick("퇴근이 이미 되어 있습니다.")
                      : hasCommute.출근
                      ? () => handleCommute("퇴근")
                      : () => handleDisabledClick("출근을 먼저 해주세요.")
                }
                // onClick={() => handleCommute("퇴근")}
                btnText="퇴근"
                disabled={!hasCommute.출근 || hasCommute.퇴근 || loading}
              />
            </>
          ): (
            <CommuteBox
              text="기업 GPS 등록하기"
              icon= {assets.icons.red_pin}
              // onClick = {enrollGps}
              btnText="등록하기"
              disabled = {baseGpsExist}
            />
          )}
          
        </div>
        <div style={styles.rowCalendar}>
          <CommuteCalendar style={{width: "697px",}} checkResult={data}/>
          <div className="commonComponent" style={{flex: "1"}}></div>
        </div>
      </div>
    );
  }
  
}

const styles ={
  container:{
    padding: "16px",
    display:"flex",
    flexDirection: "column",
  },
  rowBox:{
    display:"flex",
    gap: "20px",
    marginBottom: "20px",
    height:"107px",
  },
  rowCalendar:{
    flex:"1",
    display:"flex",
    gap:"20px",    
  }
}

const mobileStyles ={
  container:{
    padding: "16px",
    display:"flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%"
  },
  rowBox:{
    display:"flex",
    gap: "20px",
    flexDirection: "column",
    marginBottom: "20px",
  },
}

export default Commute;